import { ErrorCode, i18nKey, } from "@shared";
/**
 * The message to show for a join that failed. Every failure maps to one, so a failed join is
 * never silent.
 */
export function joinGroupFailureMessage(resp, level) {
    switch (resp.kind) {
        case "blocked":
            return i18nKey("youreBlocked");
        case "error":
            return resp.code === ErrorCode.InitiatorBlocked
                ? i18nKey("youreBlocked")
                : i18nKey("joinGroupFailed", undefined, level, true);
        case "failure":
        case "internal_error":
            return i18nKey("joinGroupFailed", undefined, level, true);
    }
}
/**
 * The group or community an anonymous user asked to join, once they have logged in and their
 * chats and communities have loaded. The caller clears the post-login state before joining, so the
 * join is replayed once.
 */
export function postLoginJoin(identityState, chatsInitialised) {
    if (identityState.kind !== "logged_in" || !chatsInitialised)
        return undefined;
    switch (identityState.postLogin?.kind) {
        case "join_group":
        case "join_community":
            return identityState.postLogin;
        default:
            return undefined;
    }
}
/**
 * Whether an anonymous user who asked to create a community has now logged in, so creating it
 * picks up where it left off. The caller clears the post-login state first, so it runs once.
 */
export function postLoginCreateCommunity(identityState) {
    return (identityState.kind === "logged_in" && identityState.postLogin?.kind === "create_community");
}
